import { useState, useEffect, useRef } from "react";
import { Bird, X, Download } from "lucide-react";

export default function PWAInstallPrompt() {
  const [show, setShow] = useState(false);
  const deferredPromptRef = useRef(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("pwa-prompt-dismissed") === "1");

  useEffect(() => {
    if (dismissed) return;

    // Don't show if already installed (standalone mode)
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const handler = (e) => {
      e.preventDefault();
      deferredPromptRef.current = e;
      // Show after a small delay so user sees the hub first
      setTimeout(() => setShow(true), 2000);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, [dismissed]);

  const handleInstall = async () => {
    if (!deferredPromptRef.current) return;
    deferredPromptRef.current.prompt();
    const result = await deferredPromptRef.current.userChoice;
    if (result.outcome === "accepted") {
      setShow(false);
    }
    deferredPromptRef.current = null;
  };

  const handleDismiss = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem("pwa-prompt-dismissed", "1");
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] animate-slideInUp" data-testid="pwa-install-prompt">
      <div className="max-w-sm mx-auto bg-slate-950 text-white rounded-2xl shadow-2xl border border-slate-800 p-4">
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center shrink-0 shadow-lg shadow-red-600/30">
            <Bird className="w-6 h-6 text-white" strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-black tracking-tight">Add Pigeon Supply</h3>
            <p className="text-[11px] text-slate-400 font-medium mt-0.5 leading-snug">
              Install the app for quick access to your hub. One tap from your home screen.
            </p>
          </div>
          <button onClick={handleDismiss} className="text-slate-500 hover:text-slate-300 transition-colors p-1" data-testid="pwa-dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button onClick={handleDismiss}
            className="flex-1 py-2.5 text-xs font-bold text-slate-400 bg-slate-800 rounded-xl hover:bg-slate-700 transition-colors">
            Not now
          </button>
          <button onClick={handleInstall} data-testid="pwa-install-btn"
            className="flex-1 py-2.5 text-xs font-bold text-white bg-red-600 rounded-xl hover:bg-red-500 transition-colors flex items-center justify-center gap-1.5 shadow-md">
            <Download className="w-3.5 h-3.5" /> Install
          </button>
        </div>
      </div>
    </div>
  );
}
